
import { i18nStrings as de } from './locales/de';
import { i18nStrings as en } from './locales/en';
import { i18nStrings as fr } from './locales/fr';
import { i18nStrings as nl } from './locales/nl';

const i18nStrings = {
	de: de,
	en: en,
	fr: fr,
	nl: nl,
}

export const LanguageTypes = [
	{
		"code": "en",
		"lang": "English"
	},
	{
		"code": "fr",
		"lang": "Français"
	},
	{
		"code": "de",
		"lang": "Deutsch"
	},
	{
		"code": "nl",
		"lang": "Nederlands"
	}
];

export default i18nStrings;
